export default __webpack_public_path__ + "static/logo-15e97e8999897c99408ab5c4d3ad1341.svg";